function luigiConfig() {
	return window?.fluxVars?.luigi || {};
}

function eventEndpoint() {
	const config = luigiConfig();
	return config.eventEndpoint || "";
}

function eventNonce() {
	const config = luigiConfig();
	return config.eventNonce || "";
}

function consentConfig() {
	return window?.fluxVars?.cookieConsent || {};
}

function consentCookieName() {
	return consentConfig().cookieName || "flux_privacy_consent";
}

function getCookie(name) {
	const prefix = `${name}=`;
	return (
		document.cookie
			.split(";")
			.map((cookie) => cookie.trim())
			.find((cookie) => cookie.startsWith(prefix))
			?.slice(prefix.length) || ""
	);
}

function readStoredConsent() {
	const raw = getCookie(consentCookieName());
	if (!raw) {
		return null;
	}

	try {
		return JSON.parse(decodeURIComponent(raw));
	} catch (err) {
		return null;
	}
}

function currentConsent() {
	if (window.fluxCookieConsent && typeof window.fluxCookieConsent.get === "function") {
		return window.fluxCookieConsent.get();
	}

	return readStoredConsent();
}

function consentAllows(category) {
	if (category === "necessary") {
		return true;
	}

	if (window.fluxCookieConsent && typeof window.fluxCookieConsent.has === "function") {
		return window.fluxCookieConsent.has(category);
	}

	const consent = readStoredConsent();
	const expectedVersion = consentConfig().version || "";
	if (!consent || (expectedVersion && consent.version !== expectedVersion)) {
		return false;
	}

	if (category === "advertising" && consent.gpc) {
		return false;
	}

	return Boolean(consent.categories?.[category]);
}

function sendLuigiEvent(event, payload = {}) {
	const endpoint = eventEndpoint();
	const config = luigiConfig();
	const nonce = eventNonce();
	if (!endpoint || !nonce || config.enabled === false) {
		return Promise.resolve(null);
	}
	if (!consentAllows("personalization")) {
		return Promise.resolve(null);
	}

	return fetch(endpoint, {
		method: "POST",
		credentials: "same-origin",
		keepalive: true,
		headers: {
			"Content-Type": "application/json",
			"X-WP-Nonce": nonce,
		},
		body: JSON.stringify({
			event,
			consent: currentConsent(),
			...payload,
		}),
	}).catch(() => null);
}

function bindLuigiClickTracking() {
	document.addEventListener("click", (event) => {
		const target = event.target.closest("[data-luigi-resource]");
		if (!target) {
			return;
		}

		const resourceIdentifier = target.dataset.luigiResource || "";
		if (!resourceIdentifier) {
			return;
		}

		sendLuigiEvent("click", {
			resourceIdentifier,
			actionType: target.dataset.luigiActionType || "click",
			listName: target.dataset.luigiListName || "",
			itemTitle: target.dataset.luigiItemTitle || "",
			recommendationId: target.dataset.luigiRecommendationId || "",
		});
	});
}

export function luigiAnalyticsEvents() {
	if (window.fluxTrackLuigiEvent) {
		return;
	}

	window.fluxTrackLuigiEvent = sendLuigiEvent;
	bindLuigiClickTracking();
}
